export const AsistenciaEntity = {
    id: null,
    fecRegistro: '',
    curso: {
        id: null,
        codigo: '',
        titulo: '',
    },
    user: {
        id: null,
        role: null,
        nombre: '',
        apellido: '',
        docIdentidad: '',
    },
};
